import client from "./client";
import { buildAuthAndGuestHeaders } from "./cartHeaders";

export async function checkout(payload, accessToken) {
  const res = await client.post("/order/checkout", payload, { headers: buildAuthAndGuestHeaders(accessToken) });
  return res.data;
}

export async function getMyOrders(accessToken) {
  const res = await client.get("/order/my", { headers: buildAuthAndGuestHeaders(accessToken) });
  return res.data;
}

export async function getOrder(orderGroupId, phone) {
  const res = await client.get(`/order/${orderGroupId}`, { params: phone ? { phone } : {} });
  return res.data;
}
